var _desc, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "...")), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }))), /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "scale(1,-1) translate(0,-512)",
    style: {
      clipPath: "url(#clip)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 220,
    height: 472,
    rx: 40,
    ry: 40,
    style: {
      stroke: "rgb(0%,0%,0%)",
      strokeLinecap: "butt",
      strokeWidth: 1,
      fill: "rgb(0%,0%,0%)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240,20 L 240,492 Z",
    style: {
      stroke: "rgb(100%,100%,100%)",
      strokeLinecap: "butt",
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 20,
    width: 232,
    height: 472,
    style: {
      stroke: "rgb(0%,0%,0%)",
      strokeLinecap: "butt",
      strokeWidth: 1,
      fill: "rgb(0%,0%,0%)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 360,
    width: 140,
    height: 28,
    rx: 14,
    ry: 14,
    style: {
      stroke: "rgb(0%,0%,0%)",
      strokeLinecap: "butt",
      strokeWidth: 1,
      fill: "rgb(100%,100%,100%)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 280,
    width: 140,
    height: 28,
    rx: 14,
    ry: 14,
    style: {
      stroke: "rgb(0%,0%,0%)",
      strokeLinecap: "butt",
      strokeWidth: 1,
      fill: "rgb(100%,100%,100%)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 200,
    width: 140,
    height: 28,
    rx: 14,
    ry: 14,
    style: {
      stroke: "rgb(0%,0%,0%)",
      strokeLinecap: "butt",
      strokeWidth: 1,
      fill: "rgb(100%,100%,100%)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300,256 L 440,256 Z",
    style: {
      stroke: "rgb(100%,100%,100%)",
      strokeLinecap: "butt",
      strokeWidth: 28
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400 296, 460 256, 400 216",
    style: {
      stroke: "rgb(100%,100%,100%)",
      strokeLinecap: "butt",
      strokeWidth: 28,
      fill: "none",
      fillRule: "evenodd"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.720c81cc59f8abcde8ee24494057240c.svg";
export { ForwardRef as ReactComponent };